export default __webpack_public_path__ + "static/media/background-pokedex.ef3bd511.png";